import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { pushModal } from 'loot-core/client/actions';

import { useDispatch } from '../../redux';
import { Button } from '../ui/button2';
import { InitialFocus } from '../common/InitialFocus';
import { Link } from '../common/Link';
import { Modal, ModalCloseButton, ModalHeader } from '../ui/modal';
import { Text } from '../common/Text';
import { View } from '../common/View';

type CreateAccountProps = {
  upgradingAccountId?: string;
};

export function CreateAccountModal({ upgradingAccountId }: CreateAccountProps) {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const onCreateLocalAccount = () => {
    dispatch(pushModal('add-local-account'));
  };

  let title = t('Add account');

  if (upgradingAccountId != null) {
    title = t('Link account');
  }

  return (
    <Modal name="add-account">
      {({ state: { close } }) => (
        <>
          <ModalHeader
            title={title}
            rightContent={<ModalCloseButton onClick={close} />}
          />
          <View className="text-foreground" style={{ maxWidth: 500, gap: 30 }}>
            {upgradingAccountId == null && (
              <View style={{ gap: 10 }}>
                <InitialFocus>
                  <Button
                    variant="primary"
                    style={{
                      padding: '10px 0',
                      fontSize: 15,
                      fontWeight: 600,
                    }}
                    onClick={onCreateLocalAccount}
                  >
                    {t('Create a local account')}
                  </Button>
                </InitialFocus>
                <View style={{ lineHeight: '1.4em', fontSize: 15 }}>
                </View>
              </View>
            )}
          </View>
        </>
      )}
    </Modal>
  );
}
